import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Loader from "../../../components/common/Loader";
import ApiCalling from "../../../network/ApiCalling";
import Util from "../../../Util";
import { Modal, Button } from "react-bootstrap";
import Close from "../../../assets/Icon/close.png";
import { ModalContent } from "semantic-ui-react";
import Invalid from "../../../assets/Icon/invalid.svg";
import ToastHOC from "../../HOC/ToastHOC";
import ModalComponent from "../ModalComponent";

const EnquiryStatus = (props) => {
  const { t } = useTranslation();
  const { setIsToast } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [enquiryStatusList, setEnquiryStatusList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [enquiryStatus, setEnquiryStatus] = useState("");
  const [enquiryStatusError, setEnquiryStatusError] = useState("");
  const [sort, setSort] = useState(0);
  const [sortError, setSortError] = useState("");
  const [editValue, setEditValue] = useState(null);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [isClickedOnce, setIsClickedOnce] = useState(false);
  const [deleteId, setDeleteId] = useState();
  // const [sortColumn, setSortColumn] = useState("EnquiryStatus");
  // const [sortDirection, setSortDirection] = useState("asc");

  const getEnquiryStatusList = () => {
    setIsLoading(true);
    ApiCalling.apiCallParamsGet("enquiry_status/list")
      .then((res) => {
        setEnquiryStatusList(res?.data);
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getEnquiryStatusList();
  }, []);

  const handleSaveAndClose = () => {
    setEnquiryStatusError("");
    setSortError("");
    let error = false;
    if (enquiryStatus === "") {
      setEnquiryStatusError(t("Enquiry Status is required"));
      error = true;
    }
    if (sort == 0) {
      setSortError("Sort is required");
      error = true;
    }
    if (sort) {
      const last = enquiryStatusList.length;
      const secondlast = enquiryStatusList.length - 1;
      if (sort == last || sort == 1) {
        setSortError(
          "We cannot re-oder Lead, Lost and Admitted, Please select a different order"
        );
        error = true;
      }
    }

    if (!error) {
      if (isClickedOnce) {
        return;
      }
      setIsClickedOnce(true);
      setIsLoading(true);
      if (editValue !== null) {
        const data = {
          id: editValue.id,
          status: enquiryStatus,
          order: Number(sort) + 1,
        };
        ApiCalling.apiCallBodyDataPost("enquiry_status/update", data)
          .then((res) => {
            if (res.data.status === true) {
              setShowModal(false);
              setIsLoading(false);
              setIsToast(res.data.message);

              getEnquiryStatusList();
            }
          })
          .catch((err) => {
            console.log("Error", err);
          });
      } else {
        const data = {
          status: enquiryStatus,
          order: Number(sort),
        };
        ApiCalling.apiCallBodyDataPost("enquiry_status/add", data)
          .then((res) => {
            if (res.data.status === true) {
              setShowModal(false);
              setIsLoading(false);
              setIsToast(res.data.message);

              getEnquiryStatusList();
            }
          })
          .catch((err) => {
            console.log("Error", err);
          });
      }
    }
  };

  const handleAdd = () => {
    setShowModal(true);
    setEditValue(null);
    setEnquiryStatus("");
    setEnquiryStatusError("");
    const sort = enquiryStatusList.length - 1;
    setSort(sort);
    setSortError("");
  };

  const handleClose = () => {
    setShowModal(false);
    setEnquiryStatus("");
    setEnquiryStatusError("");
    setSort(0);
    setSortError("");
  };

  const handleDelete = () => {
    setIsLoading(true);
    ApiCalling.apiCallDelete(`enquiry_status/${deleteId}`)
      .then((res) => {
        if (res.data.status) {
          setIsLoading(false);
          setIsToast(t("Enquiry Status Deleted Successfully"));
          setShowDeleteConfirmation(false);
          getEnquiryStatusList();
        } else {
          setIsLoading(false);
          setShowDeleteConfirmation(false);
          setIsToast(res?.data?.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <div className="header text-right px-0 mb-2">
            <button
              className="btn custom-primary"
              type="button"
              aria-expanded="false"
              style={{ color: "#fff", padding: "5px, 10px" }}
              onClick={handleAdd}
            >
              {t("Add Enquiry Status")}
            </button>
          </div>
        </div>

        <Modal
          show={showModal}
          onHide={handleClose}
          animation={true}
          centered={true}
          dialogClassName="modal-view"
          onShow={() => {
            setIsClickedOnce(false);
            if (editValue !== null) {
              setEnquiryStatus(editValue.status);
              setSort(editValue?.order);
            }
          }}
        >
          <div className="d-flex justify-content-between align-items center p-4 border-bottom">
            <h6>
              {editValue !== null
                ? t("Edit Enquiry Status")
                : t("Add Enquiry Status")}
            </h6>

            <button className="hidden-btn" onClick={handleClose}>
              <img src={Close} className="svg-icon" height={20} width={20} />
            </button>
          </div>
          <ModalContent isLoading={isLoading}>
            <Modal.Body>
              <div className="form-group text-start">
                <label className="basic-text required">
                  {t("Enquiry Status")}
                </label>
                <input
                  className={`form-control ${
                    enquiryStatusError.length > 0
                      ? "input-error"
                      : "custom-input"
                  }`}
                  placeholder={t("Enter Enquiry Status")}
                  type="text"
                  value={enquiryStatus}
                  onChange={(event) => {
                    setEnquiryStatus(event.target.value);
                    setEnquiryStatusError("");
                  }}
                />
                {enquiryStatusError.length > 0 && (
                  <span className="text-danger invalid-error">
                    <img
                      className="fa fa-exclamation-circle mr-2 invalid-svg"
                      src={Invalid}
                    />
                    {enquiryStatusError}
                  </span>
                )}
              </div>

              <div className="form-group text-start">
                <label className="basic-text required">{t("Sort")}</label>
                <input
                  className={`form-control ${
                    sortError.length > 0 ? "input-error" : "custom-input"
                  }`}
                  placeholder={t("Enter Sort")}
                  type="text"
                  value={sort}
                  onChange={(event) => {
                    setSort(event.target.value);
                  }}
                />
                {sortError.length > 0 && (
                  <span className="text-danger invalid-error">
                    <img
                      className="fa fa-exclamation-circle mr-2 invalid-svg"
                      src={Invalid}
                    />
                    {sortError}
                  </span>
                )}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn custom-primary"
                onClick={handleSaveAndClose}
              >
                {t("Save")}
              </Button>
            </Modal.Footer>
          </ModalContent>
        </Modal>

        <div className="row clearfix ">
          <div className="table-div overflow-hidden mt-2 p-0">
            <div className="col-lg-12 col-md-12 p-0 m-0">
              <div className="body">
                {!isLoading ? (
                  <table className="table">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">
                          {t("Status")}{" "}
                          {/* <img
                            src={Sort}
                            className="ml-1 fa-sort"
                            alt=""
                            // onClick={() => {
                            //   handleSort("observationType");
                            // }}
                          /> */}
                        </th>
                        <th scope="col"></th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    {enquiryStatusList.length > 0 ? (
                      <tbody>
                        {enquiryStatusList.map((t, index) => {
                          return (
                            <tr>
                              <td>{index + 1}</td>
                              <td>{t?.status}</td>
                              {t?.references !== "LEAD" &&
                              t?.references !== "LOST" &&
                              t?.references !== "ADMITTED" ? (
                                <td>
                                  <a
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setEditValue(t);
                                      setShowModal(true);
                                    }}
                                    className={`${
                                      !Util.hasPermission("MASTERS_EDIT") &&
                                      "no-permission"
                                    }`}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fa fa-edit"></i>
                                  </a>
                                </td>
                              ) : (
                                <td></td>
                              )}
                              {t?.references !== "LEAD" &&
                              t?.references !== "LOST" &&
                              t?.references !== "ADMITTED" ? (
                                <td>
                                  <a
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setShowDeleteConfirmation(true);
                                      setDeleteId(t.id);
                                    }}
                                    className={`${
                                      Util.hasPermission("MASTERS_DELETE")
                                        ? "pl-5"
                                        : "no-permission"
                                    }`}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fa fa-trash-o text-danger"></i>
                                  </a>
                                </td>
                              ) : (
                                <td></td>
                              )}
                            </tr>
                          );
                        })}
                      </tbody>
                    ) : (
                      <tfoot>
                        <tr>
                          <td colSpan={4}>
                            {t(
                              "There are no Enquiry Status. Click the 'Add Enquiry Status' button to create one."
                            )}
                          </td>
                        </tr>
                      </tfoot>
                    )}
                  </table>
                ) : (
                  <Loader />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalComponent
        show={showDeleteConfirmation}
        onHide={() => {
          setShowDeleteConfirmation(false);
        }}
        title={t("Delete")}
        onCancel={t("Cancel")}
        onConfirm={t("Confirm")}
        subTitle={t("Are you sure, to delete this Enquiry Status?")}
        size="sm"
        onCancelClick={() => {
          setShowDeleteConfirmation(false);
        }}
        onConfirmClick={handleDelete}
      />
    </div>
  );
};

export default ToastHOC(EnquiryStatus);
